export const ExportIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.125 6H14.6875C15.1019 6 15.4993 6.16462 15.7924 6.45765C16.0854 6.75067 16.25 7.1481 16.25 7.5625V15.0625C16.25 15.4769 16.0854 15.8743 15.7924 16.1674C15.4993 16.4604 15.1019 16.625 14.6875 16.625H5.3125C4.8981 16.625 4.50067 16.4604 4.20765 16.1674C3.91462 15.8743 3.75 15.4769 3.75 15.0625V7.5625C3.75 7.1481 3.91462 6.75067 4.20765 6.45765C4.50067 6.16462 4.8981 6 5.3125 6H6.875"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.875 10.5391L10 13.6641L13.125 10.5391"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 3V13.6641"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
